import axios from '../login/configAxios';

export const getMeApi = async () => {
	return await axios.get('/me/');
};
